import { render, staticRenderFns } from "./CatalogTree.vue?vue&type=template&id=16c3ea72&scoped=true&"
import script from "./CatalogTree.vue?vue&type=script&lang=js&"
export * from "./CatalogTree.vue?vue&type=script&lang=js&"
import style0 from "./CatalogTree.vue?vue&type=style&index=0&id=16c3ea72&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c3ea72",
  null
  
)

export default component.exports